import React, { useState } from 'react';
import classes from './pages.module.css';
import TextList from "../components/Ui/text/textList";
import ImgList from '../components/Ui/img/imgList';
import imgblock5 from '../image/imgblock5.jpeg';
import imgblock6 from '../image/imgblock6.jpeg';
import imgblock7 from '../image/imgblock7.jpeg';
import imgblock8 from '../image/imgblock8.jpeg';
import TextCol from '../components/Ui/text/textCol';
import TextFull from '../components/Ui/text/textFull';
import ListList from '../components/Ui/list/listList';

const Smart = () => {
    const [posts, setPosts] = useState([
        {id:1, body: 'Распознавание лиц' },
        {id:2, body: 'Оповещение об авариях на дорогах;' },
        {id:3, body: 'Оставленный или исчезнувший предмет;' },
        {id:4, body: 'Детектор толпы и аномального поведения;' },
        {id:5, body: 'Свободные места на парковках и распознавание госномеров;' },
        {id:6, body: 'Системы управления и планирования: рисками, инцидентами, ресурсами, задачами, документооборотом, состоянием оборудования и инвентаризацией;' },
        {id:7, body: 'Датчики отслеживание состояния окружающей среды: контроля шума, контроль загрязнения воздуха, влажность и температура.' },
    ])
    const [imgblocks, setimgblocks] = useState([
        {id:1, title: 'Нефтегаз', img: (imgblock5)},
        {id:2, title: 'Государственный сектор', img: (imgblock6)},
        {id:3, title: 'Электроэнергетика', img: (imgblock7)},
        {id:4, title: 'Операторы связи', img: (imgblock8)},
    ])
    const [lists, setlists] = useState([
        {id:1, list: 'Камеры для наблюдения за дорожными условиями и транспортным потоком;'},
        {id:2, list: 'Светодиодные индикаторы для визуального оповещения водителя об авариях;'},
        {id:3, list: 'Датчики для сбора данных об экологических и климатических условиях на дорогах;'},
        {id:4, list: 'Оборудование для сотовых операторов.'},
    ])
    const [texts, settexts] = useState([
        {id:1, content: 'Энергоэффективное освещение (LED светильник отраженного света)'},
        {id:2, content: 'Точка доступа к сети Wi-Fi (современная и защищенная сеть беспроводного доступа)'},
        {id:3, content: 'Индикационное световое кольцо (уличные сенсоры и декоративное освещение)'},
        {id:4, content: 'Тревожные кнопки и системы оповещения (система оповещения ЧС и музыкальное сопровождение)'},
        {id:5, content: 'Общая система управления функциями SmartPole SMSoft'},
        {id:6, content: 'Зарядная станция (для электротранспорта и мобильных устройств)'},
        {id:7, content: 'Реклама и интерактивные указатели (цифровой экран с возможностью показа роликов)'},
        {id:8, content: 'Система видеонаблюдения с обзором 360 (городское видеонаблюдение, Поисковые и розыскные мероприятия, мониторинг дорожного движения)'},
    ])

    return (
        <>
            <div className={classes.topBlock_small}>
                <div className={classes.top_content}>
                    <h1>Smart pole</h1>
                    <div className={classes.devider}></div>
                    <p>Башенные конструкции с широким функционалом для адаптивного управления дорожно-транспортной инфраструктурой, может служить базовым элементом умного города.</p>
                </div>
                <div className={classes.topBg_small}></div>
            </div>
            <TextFull text={{
                title: 'РЕШЕНИЕ',
                body: 'Легкие конструкции высотой до 8 метров. Smart-Pole являются идеальной инфраструктурой для всех технологий, обеспечивающих повышение безопасности и комфорта на дорогах, а также мониторинга экологии.',
                body2: 'В конструкции встроены:'
            }} lists={lists} />
            <TextCol texts={texts} title="SMART POLE ЭТО НАБОР ФУНКЦИОНАЛЬНЫХ МОДУЛЕЙ:" />
            <TextList posts={posts} title="ПРЕИМУЩЕСТВА SMART POLE:"/>
            <ImgList imgblocks={imgblocks} title="ОБЛАСТИ ПРИМЕНЕНИЯ:"/>
        </>
    )
}

export default Smart;